import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Boxes } from 'lucide-react'
import { McpScreen } from '@/screens/connect/SCR-037-mcp'

const flag = z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean())

export const Route = createFileRoute('/_app/connect/mcp')({
  staticData: { screen: { id: 'SCR-037', title: 'MCP registry', group: 'Connect', perm: 'connector.manage', order: 5, description: 'MCP servers your agents use alongside ESM: who owns them, whether they answer and which tools they offer.', icon: Boxes } },
  validateSearch: z.object({ server: z.string().max(100).optional().catch(undefined), new: flag.optional().catch(undefined) }),
  component: McpScreen,
})
